import styled from "@emotion/styled";
import { BadgeVariant } from "../../../interfaces";

export const StyledBadge = styled.span<{ $variant: BadgeVariant }>`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  font-weight: 600;
  border-radius: 9.375rem;

  background-color: ${({ theme, $variant }) => {
    if ($variant === "success") return `${theme.colors.success}20`;
    if ($variant === "danger") return `${theme.colors.danger}20`;
    if ($variant === "warning") return `${theme.colors.warning}20`;
    if ($variant === "info") return `${theme.colors.info}20`;
    return theme.colors.border;
  }};

  color: ${({ theme, $variant }) => {
    if ($variant === "success") return theme.colors.success;
    if ($variant === "danger") return theme.colors.danger;
    if ($variant === "warning") return theme.colors.warning;
    if ($variant === "info") return theme.colors.info;
    return theme.colors.text;
  }};
`;
